import { CalendarDate, DateValue, today } from '@internationalized/date';
import { RangeValue } from '@react-types/shared';
import { DateTime, Settings } from 'luxon';

import DateRangePicker from 'design-system/components/DatePicker/DateRangePicker';
import { InputSizes } from 'design-system/mixins/input';
import { TIMEZONE_NAME_ABBREVIATED } from 'lib/constants/luxonFormats';

export interface AnalyticsDateRange {
  startDate?: DateTime;
  endDate?: DateTime;
}

export interface AnalyticsDatePickerProps {
  handleDatesChangeV2: (range: RangeValue<DateValue> | null) => void;
  dateRange: AnalyticsDateRange;
  disabled?: boolean;
  id?: string;
  dataTest?: string;
  hidePresets?: boolean;
  label?: string;
  helpText?: string;
  size?: InputSizes;
}

export default function AnalyticsDatePicker({
  dataTest,
  handleDatesChangeV2,
  dateRange,
  disabled,
  helpText,
  hidePresets = false,
  label = `Dates (${DateTime.local().toFormat(TIMEZONE_NAME_ABBREVIATED)})`,
}: AnalyticsDatePickerProps) {
  return (
    <DateRangePicker
      dataTest={dataTest}
      dateRange={dateRange}
      onChange={handleDatesChangeV2}
      disabled={disabled}
      helpText={helpText}
      hidePresets={hidePresets}
      label={label}
      minDate={new CalendarDate(2018, 1, 1)}
      maxDate={today(Settings.defaultZone.name)}
    />
  );
}
